<template>
  <div class="h-[400px] mb-24">
    <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Chat</h1>
    <chat-room :room="room" />
  </div>
</template>

<script>
import fire from "@/Shared/Chat/fire";
import { uuid } from 'vue-uuid';
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import ChatRoom from '@/Shared/Chat/ChatRoom'

export default {
  inject: ['patient'],
  components: {
    ChatRoom,
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  data() {
    return {
      room: {},
      roomsUnreadMessages: [],
    }
  },
  methods: {
    async findRoom() {
      let _user_rooms = await fire.database().ref('user_rooms/' + this.user.id).once('value');
      if(_user_rooms.val()) {
        let user_rooms = Object.keys(_user_rooms.val());
        for (const user_room of user_rooms) {
          let _room = await fire.database().ref('rooms/' + user_room).once('value');
          let room = _room.val();
          if(room) {
            if(Object.keys(room.users).indexOf(this.user.id) >= 0 && Object.keys(room.users).indexOf(this.patient.user.id) >= 0) {
              room.key = _room.key;
              return room;
            }
          }
        }
      }
      return;
    },
    createRoom() {
        let roomId = uuid.v1();

        let users = {
          [`${this.user.id}`]: false,
          [`${this.patient.user.id}`]: false,
        };

        let room = {
            users: users,
            lastMessage: null,
            updatedAt: this.timestamp(),
            createdAt: this.timestamp(),
        }

        let updates = {
          [`rooms/${roomId}`]: room,
          [`user_rooms/${this.user.id}/${roomId}`]: true,
          [`user_rooms/${this.patient.user.id}/${roomId}`]: true,
        }
        fire.database().ref().update(updates);

        room.key = roomId;

        return room;
    },
    async startChat() {
      let user_room = await this.findRoom();
      if(!user_room) {
        user_room = this.createRoom();
      }

      this.room = {
        id: user_room.key,
        visible: true,
        name: this.patient.user.name,
        others: [this.patient.user.id],
        othersNames: [this.patient.user.name],
        unreadMessages: () => this.roomsUnreadMessages,
        lastMessage: user_room.lastMessage,
        users: user_room.users,
        updatedAt: user_room.updatedAt,
        createdAt: user_room.createdAt,
      };

      fire.database().ref('user_room_messages_read/' + this.user.id + '/' + user_room.key).on("value", this.loadUnreadMessages);
    },
    loadUnreadMessages(unreadMessages) {
      this.roomsUnreadMessages = {};
        unreadMessages.forEach((_unreadMessage) => {
            let unreadMessage = _unreadMessage.val();
            if(unreadMessage) {
              this.roomsUnreadMessages = Object.keys(unreadMessage);
            }
        });
    },
    timestamp() {
      return fire.database.ServerValue.TIMESTAMP;
    },
    findUser(id) {
      if(this.patient.user.id == id) {
        return this.patient.user;
      }
      return {};
    },
  },
  mounted() {
    this.startChat();
  },
}
</script>